import { render } from "./UsersTable.vue?vue&type=template&id=2404970f&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"

import "./UsersTable.vue?vue&type=style&index=0&id=2404970f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2404970f"]])

export default __exports__